let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kKbft")).then(() => parcelRequire('hYna3'));